export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_DV360 = 'ROLE_DV360';
export const ROLE_SDF = 'ROLE_SDF';
